var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-svgrepo-com1 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3682 5.5837C16.7069 4.23986 18.7687 4.13092 19.9735 5.34037C21.1783 6.54983 21.0698 8.61965 19.7311 9.96349L17.7921 11.9101M11.2478 14.1C10.043 12.8906 10.1515 10.8207 11.4902 9.47687L13.2106 7.7497",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.3734 10.8999C15.5782 12.1093 15.4697 14.1792 14.131 15.523L12.192 17.4696L10.2529 19.4162C8.9143 20.7601 6.85244 20.8689 5.64767 19.6595C4.44289 18.4501 4.55142 16.3802 5.89006 15.0364L7.82913 13.0897",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteink);
export default __webpack_public_path__ + "static/media/Websiteink.a239a2072948057245c7831662b5d933.svg";
export { ForwardRef as ReactComponent };